export default __webpack_public_path__ + "554b4013e26e99b9c55594e4096db7f7.glb";